var _defs, _rect, _text, _text2, _rect2, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductDocumentManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1400,
    height: 800,
    viewBox: "0 0 1400 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gGreen",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4CAF50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2E7D32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gBlue",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2196F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1565C0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 10,
    stdDeviation: 12,
    floodColor: "#0B1220",
    floodOpacity: 0.12
  })), /*#__PURE__*/React.createElement("style", null, "\r\n      .bg { fill: #F8FAFC; }\r\n      .card { fill: #FFFFFF; stroke: rgba(15,23,42,0.08); filter: url(#shadow); }\r\n      .muted { fill: #4A5568; font-family: Inter, Roboto, Arial, sans-serif; }\r\n      .title { fill: #1A202C; font-family: Inter, Roboto, Arial, sans-serif; font-weight: 800; }\r\n      .label { fill: #1A202C; font-family: Inter, Roboto, Arial, sans-serif; font-weight: 600; }\r\n      .chipOk { fill: rgba(76,175,80,0.12); stroke: rgba(76,175,80,0.25); }\r\n      .chipDup { fill: rgba(255,193,7,0.18); stroke: rgba(255,111,0,0.25); }\r\n      .chipTxt { font-family: Inter, Roboto, Arial, sans-serif; font-weight: 700; font-size: 12px; }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "bg",
    width: 1400,
    height: 800
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "title",
    x: 80,
    y: 95,
    fontSize: 34
  }, "Document Management (auto-processing + duplicates)")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 80,
    y: 130,
    fontSize: 16
  }, "Upload bills/invoices, extract fields, compute CO\u2082 signals, and flag duplicates for clean reporting.")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "card",
    x: 80,
    y: 170,
    width: 1240,
    height: 560,
    rx: 24
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(130,220)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 260,
    height: 90,
    rx: 20,
    fill: "#FFFFFF",
    stroke: "rgba(76,175,80,0.18)",
    filter: "url(#shadow)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 22,
    y: 34,
    fontSize: 12
  }, "Total documents"), /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 22,
    y: 68,
    fontSize: 28
  }, "1,248")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 260,
    height: 90,
    rx: 20,
    fill: "#FFFFFF",
    stroke: "rgba(33,150,243,0.18)",
    filter: "url(#shadow)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 22,
    y: 34,
    fontSize: 12
  }, "Total amount"), /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 22,
    y: 68,
    fontSize: 26
  }, "\u20B9 38.6L")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 260,
    height: 90,
    rx: 20,
    fill: "#FFFFFF",
    stroke: "rgba(33,150,243,0.18)",
    filter: "url(#shadow)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 22,
    y: 34,
    fontSize: 12
  }, "CO\u2082 emissions (from docs)"), /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 22,
    y: 68,
    fontSize: 26,
    fill: "#1565C0"
  }, "4,120 kg")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 260,
    height: 90,
    rx: 20,
    fill: "#FFFFFF",
    stroke: "rgba(255,111,0,0.20)",
    filter: "url(#shadow)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 22,
    y: 34,
    fontSize: 12
  }, "Duplicates found"), /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 22,
    y: 68,
    fontSize: 26,
    fill: "#B45309"
  }, "37")))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(130,340)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 0,
    y: 0,
    fontSize: 16
  }, "All documents"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 0,
    y: 22,
    fontSize: 13
  }, "Search + filter by status/type; investigate extracted fields and carbon footprint."), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 40,
    width: 1140,
    height: 330,
    rx: 22,
    fill: "#FFFFFF",
    stroke: "rgba(148,163,184,0.35)",
    filter: "url(#shadow)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 40,
    width: 1140,
    height: 54,
    rx: 22,
    fill: "rgba(33,150,243,0.06)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 22,
    y: 76,
    fontSize: 12
  }, "Document"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 500,
    y: 76,
    fontSize: 12
  }, "Type"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 640,
    y: 76,
    fontSize: 12
  }, "Status"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 800,
    y: 76,
    fontSize: 12
  }, "Amount"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 940,
    y: 76,
    fontSize: 12
  }, "Date"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,104)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1140,
    height: 56,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 22,
    y: 34,
    fontSize: 13
  }, "Electricity_Bill_May.pdf"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 500,
    y: 34,
    fontSize: 13
  }, "Bill"), /*#__PURE__*/React.createElement("rect", {
    className: "chipOk",
    x: 620,
    y: 16,
    width: 110,
    height: 26,
    rx: 13
  }), /*#__PURE__*/React.createElement("text", {
    className: "chipTxt",
    x: 645,
    y: 34,
    fill: "#2E7D32"
  }, "PROCESSED"), /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 800,
    y: 34,
    fontSize: 13
  }, "\u20B9 1,14,200"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 940,
    y: 34,
    fontSize: 13
  }, "2025-05-31")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,160)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1140,
    height: 56,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 22,
    y: 34,
    fontSize: 13
  }, "Diesel_Invoice_0421.png"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 500,
    y: 34,
    fontSize: 13
  }, "Invoice"), /*#__PURE__*/React.createElement("rect", {
    className: "chipDup",
    x: 620,
    y: 16,
    width: 110,
    height: 26,
    rx: 13
  }), /*#__PURE__*/React.createElement("text", {
    className: "chipTxt",
    x: 650,
    y: 34,
    fill: "#B45309"
  }, "DUPLICATE"), /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 800,
    y: 34,
    fontSize: 13
  }, "\u20B9 28,650"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 940,
    y: 34,
    fontSize: 13
  }, "2025-04-21")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,216)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1140,
    height: 56,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 22,
    y: 34,
    fontSize: 13
  }, "Raw_Material_Steel_Mar.pdf"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 500,
    y: 34,
    fontSize: 13
  }, "Invoice"), /*#__PURE__*/React.createElement("rect", {
    className: "chipOk",
    x: 620,
    y: 16,
    width: 110,
    height: 26,
    rx: 13
  }), /*#__PURE__*/React.createElement("text", {
    className: "chipTxt",
    x: 645,
    y: 34,
    fill: "#2E7D32"
  }, "PROCESSED"), /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 800,
    y: 34,
    fontSize: 13
  }, "\u20B9 6,42,000"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 940,
    y: 34,
    fontSize: 13
  }, "2025-03-18")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,286)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1140,
    height: 84,
    rx: 18,
    fill: "rgba(76,175,80,0.06)",
    stroke: "rgba(76,175,80,0.18)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 22,
    y: 34,
    fontSize: 14
  }, "Why this matters"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 22,
    y: 58,
    fontSize: 13
  }, "Clean, structured evidence enables audit-ready reporting and stronger underwriting signals for green finance."), /*#__PURE__*/React.createElement("rect", {
    x: 900,
    y: 22,
    width: 218,
    height: 42,
    rx: 14,
    fill: "url(#gBlue)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 950,
    y: 49,
    fontSize: 13,
    fill: "#FFFFFF",
    fontFamily: "Inter, Roboto, Arial, sans-serif",
    fontWeight: 800
  }, "View extracted data")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductDocumentManagement);
export default __webpack_public_path__ + "static/media/product-document-management.c1b7b05c76882194e503a4ca245ff280.svg";
export { ForwardRef as ReactComponent };